import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function HandlingAndMerchantConcerns({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});

  const handleCheckboxChange = (e) => {
    const { name, value, checked } = e.target;

    setPrimaryDetails((prev) => {
      const currentValues = prev[name] || [];
      if (checked) {
        return { ...prev, [name]: [...currentValues, value] };
      } else {
        return { ...prev, [name]: currentValues.filter((item) => item !== value) };
      }
    });
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const errors = {};
    // If no concerns selected, flag error
    // if (
    //   (!primaryDetails.merchant_transaction || primaryDetails.merchant_transaction.length === 0) 
    // ) {
    //   errors.merchant_transaction = true;
    // }
    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    // Check if at least one concern is selected or if the other concern field is filled
    const hasSelectedConcern = primaryDetails.rm_concern || primaryDetails.merchant_concern;
    const hasOtherConcern = primaryDetails.rm_merchant_other_concern && primaryDetails.rm_merchant_other_concern.trim() !== "";
    const hasTransactionInfo = primaryDetails.merchant_transaction && primaryDetails.merchant_transaction.trim() !== "";
    
    return hasSelectedConcern || hasOtherConcern || hasTransactionInfo;
  }
  const handleNext = () => {
    if (validateForm()) {
      navigation.go("maya-merchant-survey");
    } else {
      toast.error("Please select at least one concern or provide details.");
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  const irmHandlingOptions = [
    "Change in merchant details",
    "Change in terminal type request (TERMINAL UPGRADE)",
    "Additional terminal request",
    "Terminal pullout requests",
    "Competitor is using Maya thermal roll",
  ];

  const merchantConcernOptions = [
    "Account issues",
    "Reversal transaction",
    "Settlement issue",
    "Competitor priority",
    "High cash payment",
    "Low foot traffic",
    "Pending status of Maya POS/QR",
    "Change tagging under Maya",
    "Maya Relationship Manager (RM) issue",
  ];

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">RM HANDLING AND MERCHANT CONCERNS</h4>
              <p className="form-desc">Check all that apply and provide details if necessary</p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">

                  {/* RM Handling Concerns */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">RM Handling Concerns</Form.Label>
                    <Form.Select
                      name="rm_concern"
                      value={primaryDetails.rm_concern || ''}
                      onChange={handleTextChange}
                      className="form-select"
                    >
                      <option value="">Select RM handling concern</option>
                      {irmHandlingOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  {/* Merchant Concerns */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Merchant Concerns</Form.Label>
                    <Form.Select
                      name="merchant_concern"
                      value={primaryDetails.merchant_concern || ''}
                      onChange={handleTextChange}
                      className="form-select"
                    >
                      <option value="">Select merchant concern</option>
                      {merchantConcernOptions.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  {/* Other Concerns */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Other RM Handling or Merchant Concerns</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="rm_merchant_other_concern"
                      value={primaryDetails.rm_merchant_other_concern || ""}
                      onChange={handleTextChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  {/* Zero to Low Transaction Merchant */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Zero to Low Transaction Merchant
                      <span className="form-required">*</span>
                    </Form.Label>

                    <Form.Select
                      name="merchant_transaction"
                      value={primaryDetails.merchant_transaction || ''}
                      onChange={handleTextChange}
                      className="form-select"
                    >
                      <option value="">Select option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  {/* Has Terminal Concern */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Has Terminal Concern
                    </Form.Label>
                    <Form.Select
                      name="terminal_concern"
                      value={primaryDetails.terminal_concern || ""}
                      onChange={handleTextChange}
                      className="form-select"
                    >
                      <option value="">Select Option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  {/* Has SQR Concern */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Has SQR Concern</Form.Label>
                    <Form.Select
                      name="sqr_concern"
                      value={primaryDetails.sqr_concern || ''}
                      onChange={handleTextChange}
                      className="form-select"
                    >
                      <option value="">Select option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>

                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default HandlingAndMerchantConcerns;
